"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableVector3 = void 0;
const Vector3_1 = require("./Vector3");
class ObservableVector3 extends Vector3_1.Vector3 {
    constructor(cb, x = 0, y = 0, z = 0) {
        super();
        this._x = x;
        this._y = y;
        this._z = z;
        Object.defineProperties(this, {
            _x: {
                enumerable: false,
                value: x,
            },
            _y: {
                enumerable: false,
                value: y,
            },
            _z: {
                enumerable: false,
                value: z,
            },
            _cb: {
                configurable: false,
                enumerable: false,
                writable: false,
                value: cb,
            },
        });
    }
    get x() {
        return this._x;
    }
    set x(value) {
        const oldPoint = this.clone();
        this._x = value;
        this.notify(this, oldPoint);
    }
    get y() {
        return this._y;
    }
    set y(value) {
        const oldPoint = this.clone();
        this._y = value;
        this.notify(this, oldPoint);
    }
    get z() {
        return this._z;
    }
    set z(value) {
        const oldPoint = this.clone();
        this._z = value;
        this.notify(this, oldPoint);
    }
    notify(newPoint, oldPoint) {
        if (this._cb)
            this._cb(newPoint, oldPoint);
    }
    set(x, y, z) {
        const oldPoint = this.clone();
        this._x = x;
        this._y = y;
        this._z = z;
        this.notify(this, oldPoint);
        return this;
    }
    toObject() {
        return {
            x: this.x,
            y: this.y,
            z: this.z,
        };
    }
    toArray() {
        return [this.x, this.y, this.z];
    }
    valueOf() {
        return this.toObject();
    }
}
exports.ObservableVector3 = ObservableVector3;
